import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Nenhum link ainda',
  hint: 'Os links e cupons rastreáveis são criados pela equipe Bodyprint. Quando o seu estiver pronto, ele aparece aqui com os cliques, os cadastros e as comissões. Para pedir um, fale com o seu contato na Bodyprint.',
} satisfies TranslationTree;
